import { cn } from "../lib/utils";

export function Logo({ className, variant = "dark" }) {
  const textColor = variant === "dark" ? "#0A2540" : "#FFFFFF";
  const accentColor = "#00C4A0";

  return (
    <div className={cn("flex items-center gap-2.5 select-none", className)}>
      <svg viewBox="0 0 44 44" xmlns="http://www.w3.org/2000/svg" className="h-9 w-9 shrink-0" aria-hidden="true">
        <circle cx="22" cy="22" r="20" fill="none" stroke={textColor} strokeWidth="1" strokeOpacity="0.9" />
        <circle cx="22" cy="2" r="1.6" fill={accentColor} />
        <text x="22" y="26.5" textAnchor="middle" fontFamily="Instrument Serif, Georgia, serif" fontStyle="italic" fontSize="13" fill={textColor} letterSpacing="0.5">365</text>
      </svg>
      <span className="font-sans text-[1.05rem] font-medium tracking-tight" style={{ color: textColor }}>
        Asset<span className="font-display italic font-normal">Care</span>
      </span>
    </div>
  );
}
